import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MessageDialogConfig } from './message-dialog-config.interface';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
    selector: 'ca-error-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrl: './message-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DialogHeaderComponent, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatIcon, NgClass]
})
export class MessageDialogComponent {
    public dialogRef = inject<MatDialogRef<MessageDialogComponent>>(MatDialogRef);
    public data = inject<MessageDialogConfig>(MAT_DIALOG_DATA);

    public onCancel(): void {
        this.dialogRef.close({ cancel: true });
    }
}
